import {Model} from '@vuex-orm/core';
import {IUnitPlanComments} from "../../interfaces/units/IUnitPlanComments";

// @ts-ignore
export default class UnitPlanComments extends Model implements IUnitPlanComments {
  static entity = 'comments';

  static fields() {
    return {
      id: this.number(0),
      idPlanUnidadOA: this.number(0).nullable(),
      idPlanUnidad: this.number(0).nullable(),
      idPlanUnidadActividad: this.number(0).nullable(),
      userFullName: this.string(''),
      title: this.string('').nullable(),
      tipoComentario: this.string(''),
      fecha: this.string(''),
      descripcion: this.string(''),
      estadoPlan: this.string(''),
      created_at: this.string(new Date().toISOString().substr(0, 10)),
      update_at: this.string(new Date().toISOString().substr(0, 10)),

      //unitplan: this.belongsTo(UnitPlan, 'id'),
    };
  }
}
